import { useEffect, useRef } from "react";
import useSkin from "src/hooks/useSkin";

const MANENO_TITLE = "Maneno LMS";
const GRIFFLE_TITLE = "Griffin LMS";

const MANENO_DESCRIPTION =
  "Spark a love of reading with Maneno. Read 9000+ books. Play with the Maneno dragon. Learn new words and build self-confidence. For ages 6-12. Start reading for free.";
const GRIFFLE_DESCRIPTION =
  "Griffin LMS — manage reading assignments, track student progress, and explore a library of 9000+ books.";

const MANENO_THEME_COLOR = "#165b95";
const GRIFFLE_THEME_COLOR = "#539a18";

const ICON_SELECTOR = 'link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]';

interface SavedIcon {
  rel: string;
  href: string;
  type: string;
  sizes: string;
}

function setMeta(property: string, content: string, attr = "name") {
  let el = document.querySelector(`meta[${attr}="${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, property);
    document.head.appendChild(el);
  }
  el.content = content;
}

const SkinHead = () => {
  const { isGriffle } = useSkin();
  const originalIcons = useRef<SavedIcon[] | null>(null);

  useEffect(() => {
    if (originalIcons.current === null) {
      const icons = document.querySelectorAll<HTMLLinkElement>(ICON_SELECTOR);
      originalIcons.current = Array.from(icons).map((el) => ({
        rel: el.rel,
        href: el.href,
        type: el.type || "",
        sizes: el.getAttribute("sizes") || ""
      }));
    }
  }, []);

  useEffect(() => {
    const title = isGriffle ? GRIFFLE_TITLE : MANENO_TITLE;
    const description = isGriffle ? GRIFFLE_DESCRIPTION : MANENO_DESCRIPTION;
    const themeColor = isGriffle ? GRIFFLE_THEME_COLOR : MANENO_THEME_COLOR;

    document.title = title;

    const icons = document.querySelectorAll<HTMLLinkElement>(ICON_SELECTOR);

    if (isGriffle) {
      icons.forEach((el) => {
        el.href = "/griffle/favicon.svg";
        el.type = "image/svg+xml";
        el.removeAttribute("sizes");
      });
    } else if (originalIcons.current) {
      const originals = originalIcons.current;
      icons.forEach((el, i) => {
        if (originals[i]) {
          el.href = originals[i].href;
          el.type = originals[i].type;
          if (originals[i].sizes) {
            el.setAttribute("sizes", originals[i].sizes);
          }
        }
      });
    }

    setMeta("description", description);
    setMeta("theme-color", themeColor);

    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:site_name", isGriffle ? "Griffin" : "Maneno", "property");

    setMeta("twitter:card", "summary", "name");
    setMeta("twitter:title", title, "name");
    setMeta("twitter:description", description, "name");
  }, [isGriffle]);

  return null;
};

export default SkinHead;
